// Hr — línea horizontal de 1 px en color line.

export default function Hr({ className = '' }) {
  return <div className={`h-px bg-[var(--line)] ${className}`} />
}
